/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `IntegrationDetail.ts` file.
 ******/
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

import { IntegrationDetail } from "./IntegrationDetail";

import { Project } from "./Project";

export abstract class IntegrationDetailModel {
    id: number;
    createdAt: Dayjs;
    data: any | null;
    projectId: number;
    updatedAt: Dayjs;
    project: Project | null | undefined;
    _destroy: boolean | undefined;

    constructor(
        id: number,
        createdAt: Dayjs,
        data: any | null,
        projectId: number,
        updatedAt: Dayjs,
        project: Project | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.data = data;
        this.projectId = projectId;
        this.updatedAt = updatedAt;
        this.project = project;
    }

    static fromApiObject(json: any, timezone: string): IntegrationDetail {
        const newObject = new IntegrationDetail(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["data"],
            json["project_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone)
        );

        return newObject;
    }

    toApiObject(): any {
        return {
            id: this.id,
            created_at: this.createdAt,
            data: this.data,
            project_id: this.projectId,
            updated_at: this.updatedAt,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): IntegrationDetail {
        const clone = Object.create(this) as IntegrationDetail;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
